// React
import { useMemo } from "react"

// React Router
import { useParams, useNavigate } from "react-router-dom"

// Redux
import { useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"

// MUI
import { Grid, Icon } from "@mui/material"

// Components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MyTasksLXO from "components/MyTasksLXO/MyTasksLXO"
import ClassSituation from "components/ClassSituation/ClassSituation"
import TeacherManagement from "components/TeacherManagement/TeacherManagement"

// Icons
import AssistantMail from "components/icons/AssistantMail"
import AssistantBox from "components/icons/AssistantBox"

// Styles
import { noteTypography } from "shared/styles/style"
import ClassSituationLXO from "components/ClassSituationLXO/ClassSituationLXO"

const tabs = [
  {
    icon: () => <AssistantBox />,
    title: "My tasks",
    link: "my-tasks",
  },
  {
    icon: () => <AssistantMail />,
    title: "Class Situation",
    link: "class-situation",
  },
  {
    icon: () => <AssistantMail />,
    title: "Teacher Management",
    link: "teacher-management",
  },
]

export default function AssistantLXO({ defaultTabLink = "my-tasks" }) {
  const auth = useSelector(selectAuth)
  const { tab } = useParams()
  const navigate = useNavigate()

  const tabIndex = useMemo(() => {
    const index = tabs.findIndex((_tab) => _tab.link === (tab || defaultTabLink))
    return index === -1 ? 0 : index
  }, [tab, defaultTabLink])
  const renderContent = useMemo(() => {
    const link = tabs[tabIndex]?.link
    switch (link) {
      case "my-tasks":
        return <MyTasksLXO />
      case "class-situation":
        return <ClassSituationLXO />
      case "teacher-management":
        return <TeacherManagement />
      default:
        return null
    }
  }, [tabIndex])

  return (
    <MDBox
      className={`assistant ${
        tabIndex === 1 ? "assistant--class-situation" : ""
      }`}
    >
      <MDBox className={`assistant__header-box`}>
        <MDBox display="flex" alignItems="center" gap={3}>
          <MDBox
            component="img"
            src={auth?.user?.avatar}
            className={`assistant__avatar`}
          ></MDBox>
          <MDBox>
            <MDTypography className={`assistant__full-name`}>
              {auth?.user?.fullName}
            </MDTypography>
            <MDTypography className={`assistant__role`}>
              {auth?.role}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Grid
          container
          className={`assistant__tab-wrapper`}
          alignItems="center"
          sx={{ gap: "4px" }}
        >
          {tabs.map((item, index) => {
            const getXlValue = (count) => {
              if (count === 3) return 4
              if (count === 4) return 3
              return 3
            }
            const xlValue = getXlValue(tabs.length)
            return (
              <Grid
                item
                sx={{ width: "calc(100%/3 - 4px)" }}
                key={index}
                className={`${`assistant__tab-item`} ${
                  index === tabIndex && `active`
                }`}
                onClick={() => {
                  navigate(`/assistant/${item.link}`)
                }}
              >
                <Icon component={item.icon} />
                <MDTypography
                  sx={({ breakpoints }) => ({
                    ...noteTypography(breakpoints),
                    lineHeight: 1.25,
                  })}
                >
                  {item.title}
                </MDTypography>
              </Grid>
            )
          })}
        </Grid>
      </MDBox>
      {renderContent}
    </MDBox>
  )
}
